// DatenschutzPage.jsx
import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import Navbar from 'scenes/widgets/navbar';
import Footer from 'scenes/widgets/footer';

const DatenschutzPage = () => {
  const theme = useTheme();

  return (
    <Box>
      <Navbar />
      <Box
        sx={{
          padding: '40px 20px',
          maxWidth: '800px',
          margin: '0 auto',
          backgroundColor: theme.palette.background.paper,
          lineHeight: 1.6,
        }}
      >
        <Typography variant="h3" gutterBottom sx={{ textAlign: 'center', mb: 4 }}>
          Datenschutzerklärung für Kunstkaleidoskop
        </Typography>

        <Typography variant="body1" paragraph>
          Ein vertrauensvoller und sicherer Umgang mit personenbezogenen Daten ist uns sehr wichtig.
          Wir beachten die Vorschriften der EU-Datenschutzgrundverordnung (DS-GVO), des Bundesdatenschutzgesetzes (BDSG)
          sowie weiterer europäischer Regelungen und möchten Sie in dieser Datenschutzerklärung ausführlich und transparent
          über die Verarbeitung Ihrer personenbezogenen Daten informieren.
        </Typography>

        <Typography variant="body1" paragraph>
          Personenbezogene Daten sind alle Daten, die auf Sie persönlich beziehbar sind, z. B. Name, Adresse,
          E-Mail-Adressen oder Nutzerverhalten. Hinsichtlich der weiteren nachfolgend verwendeten Begriffe,
          wie bspw. „Verantwortlicher" oder „Auftragsverarbeiter", verweisen wir auf den Definitionskatalog
          der Begriffsbestimmungen in Art. 4 DS-GVO.
        </Typography>

        <Typography variant="h4" gutterBottom sx={{ mt: 4, mb: 2 }}>
          1. Verantwortlicher
        </Typography>
        <Typography variant="body1" paragraph>
          Die Verarbeitung personenbezogener Daten im Zusammenhang mit der Webseite https://www.kunstkaleidoskop.de erfolgt durch die
        </Typography>
        <Typography variant="body1" paragraph sx={{ ml: 2 }}>
          MediConsult GmbH<br />
          Cremon 11<br />
          20457 Hamburg, DE<br />
          („Kunstkaleidoskop", „wir")<br />
          E‑Mail: info@kunstkaleidoskop.de
        </Typography>

        <Typography variant="h4" gutterBottom sx={{ mt: 4, mb: 2 }}>
          2. Erhobene Daten & Zwecke
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ mt: 3, mb: 1 }}>
          a) Allgemeiner Website‑Betrieb
        </Typography>
        <Typography variant="body1" paragraph>
          Automatisch erhobene technische Daten (z. B. IP‑Adresse, Zugriffszeit, Browserinfos) zur sicheren
          und reibungslosen Bereitstellung der Webseite (Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO).
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ mt: 3, mb: 1 }}>
          b) Analyse‑Tools & Marketingdienste
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Google Analytics:</strong> Erfassung pseudonymer Nutzerprofile zur Analyse der Webseitennutzung.
          IP‑Anonymisierung aktiviert, Datenübermittlung ggf. in die USA basierend auf EU‑Standardvertragsklauseln
          oder Privacy Framework.
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Brevo (E-Mail‑Marketing, vormals Sendinblue):</strong> Verarbeitung von E‑Mail‑Adressen und
          optional weiteren Angaben (Einwilligungsgrundlage: Art. 6 Abs. 1 lit. a DSGVO).
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Zapier:</strong> Automatisierte Weiterleitung von Daten zwischen Diensten. Datenverarbeitung auf
          Basis eurer Einwilligung oder berechtigter Interessen (z. B. Effizienzsteigerung)
          (Art. 6 Abs. 1 lit. a oder f DSGVO).
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>HubSpot:</strong> Verwendung zur Verwaltung von Kontakt- und Marketingdaten; Datenverarbeitung
          auf Basis eurer Einwilligung und zur Betriebspflicht unter gesicherten Rahmenbedingungen
          (Art. 6 Abs. 1 lit. a, ggf. Vertrag zur Auftragsverarbeitung).
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ mt: 3, mb: 1 }}>
          c) Teilnahme am Kunstkaleidoskop‑Wettbewerb
        </Typography>
        <Typography variant="body1" paragraph>
          Folgende Pflichtangaben werden von den Erziehungsberechtigten im Rahmen der Teilnahme erhoben:
        </Typography>
        <Typography variant="body1" component="div" sx={{ ml: 2, mb: 2 }}>
          • Vor‑ und Nachname Erziehungsberechtigter<br />
          • E‑Mail‑Adresse Erziehungsberechtigter<br />
          • Vor‑ und Nachname des Kindes<br />
          • vom/den Erziehungsberechtigten gewählter individueller anonymer Nutzername<br />
          • Teilnahmebestätigungen via Checkboxen:<br />
          &nbsp;&nbsp;◦ Über 18 & handeln als Erziehungsberechtigter – Akzeptanz der Datenschutzerklärung<br />
          &nbsp;&nbsp;◦ Zustimmung zur Datenschutzerklärung<br />
          &nbsp;&nbsp;◦ Pflicht-Abonnement unseres Newsletters (z. B. Gutscheine, Einladungen)
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Zweck der Daten:</strong> Gewährleistung des korrekten Teilnehmerabgleichs (Schutz vor Verwechslungen),
          Auszahlung der Teilnahmebelohnung (9,90 €) und Newsletter-Zustellung. Rechtsgrundlagen: Einwilligung
          (Art. 6 Abs. 1 lit. a DSGVO) sowie berechtigtes Interesse an sicherer Abwicklung.
        </Typography>
        <Typography variant="body1" paragraph>
          Datenverarbeitung erfolgt nur mit elterlicher Zustimmung und wird nicht für andere Zwecke verwendet.
        </Typography>
        <Typography variant="body1" paragraph>
          Eingereichte Fotos oder Kurzvideos (max. 4 Fotos, max. 30 Sekunden Video) werden zur Bewertung des
          Wettbewerbs gespeichert. Nach Abschluss des Wettbewerbs werden sie gelöscht oder anonymisiert.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ mt: 3, mb: 1 }}>
          d) Newsletter
        </Typography>
        <Typography variant="body1" paragraph>
          Abonnement erfolgt über Pflichtfeld beim Wettbewerb – berechtigte Information (z. B. Gutscheine, Einladungen).
          Rechtsgrundlage: Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
        </Typography>

        <Typography variant="h4" gutterBottom sx={{ mt: 4, mb: 2 }}>
          3. Empfänger & Drittstaatentransfer
        </Typography>
        <Typography variant="body1" paragraph>
          Google, Brevo, Zapier, HubSpot sind Drittanbieter. Datenübermittlung erfolgt nur bei entsprechender
          Einwilligung bzw. DSGVO-konformen Rahmen (z. B. Auftragsverarbeitung, EU‑Standardvertragsklauseln,
          EU‑US Privacy Framework).
        </Typography>
        <Typography variant="body1" paragraph>
          Die personenbezogenen Daten der Wettbewerbsteilnehmer/Eltern werden nicht an unbeteiligte Dritte weitergegeben.
        </Typography>

        <Typography variant="h4" gutterBottom sx={{ mt: 4, mb: 2 }}>
          4. Speicherdauer
        </Typography>
        <Typography variant="body1" component="div" sx={{ ml: 2 }}>
          • <strong>Newsletter-Daten:</strong> bis Widerruf oder regelmäßige Löschung nach [z. B. 3 Jahren].<br />
          • <strong>Wettbewerbsbezogene Daten</strong> (Name, Nutzername, Fotos/Videos): solange wie zur Abwicklung
          notwendig, spätestens nach Abschluss des Wettbewerbs sowie nach Fristen zur Abwicklung der Auszahlung (z. B. 1 Jahr).<br />
          • <strong>Allgemeine Websitestatistiken</strong> (Google Analytics): etwa 14 Monate (Standardkonfiguration).
        </Typography>

        <Typography variant="h4" gutterBottom sx={{ mt: 4, mb: 2 }}>
          5. Rechte der Betroffenen
        </Typography>
        <Typography variant="body1" paragraph>
          Ihr habt das Recht auf:
        </Typography>
        <Typography variant="body1" component="div" sx={{ ml: 2 }}>
          • Auskunft (Art. 15 DSGVO)<br />
          • Berichtigung, Löschung, Einschränkung (Art. 16–18 DSGVO)<br />
          • Widerspruch (Art. 21 DSGVO)<br />
          • Datenübertragbarkeit (Art. 20 DSGVO)<br />
          • Widerruf erteilter Einwilligungen jederzeit (Art. 7 Abs. 3 DSGVO)<br />
          • Beschwerde bei einer Aufsichtsbehörde
        </Typography>

        <Typography variant="h4" gutterBottom sx={{ mt: 4, mb: 2 }}>
          6. Freiwilligkeit & rechtliche Folgen
        </Typography>
        <Typography variant="body1" paragraph>
          Die Pflichtfelder (Eltern‑Daten, Kindes‑Daten, Benutzername, Checkboxen) sind notwendig für die Teilnahme
          am Wettbewerb und die Auszahlung der Teilnahmegebühr.
        </Typography>
        <Typography variant="body1" paragraph>
          Ohne Zustimmung und korrekte Angabe dieser Informationen ist die Teilnahme nicht möglich.
        </Typography>

        <Typography variant="h4" gutterBottom sx={{ mt: 4, mb: 2 }}>
          7. Sprache & Klarheit
        </Typography>
        <Typography variant="body1" paragraph>
          Diese Datenschutzerklärung wurde in klarer, leicht verständlicher Sprache verfasst – insbesondere da sie
          sich auch an Erziehungsberechtigte von Kindern richtet. Komplexe Rechtsbegriffe wurden reduziert und
          benutzerfreundlich formuliert.
        </Typography>
      </Box>
      <Footer />
    </Box>
  );
};

export default DatenschutzPage;